module.exports = __webpack_public_path__ + "static/media/temp-persona-10.68136068.jpg";